const gsap = require('../modules/gsap-utils');//test
const utilities = require('../modules/utilities');

function setupAccordions($element) {
    // $element is the accordion element itself - the parent

    if (!$element) {
        throw 'Expected an element, got ' + $element + ' instead...';
    }

    // Check for accordion-content within accordion
    // Return if there isn't any in there.
    let $accordionContent = $element.querySelector('.accordion-content'); //querySelectorAll for multiple - let's assume there's just one
    if (!$accordionContent) {
        return;
    }

    // set label element to $label
    // if it can't be found, this functionality is pointless, so return
    let $accordionLabel = $element.querySelector('.accordion-label');
    if (!$accordionLabel) {
        return;
    }

    // If Accordion Label has icon, add class
    // if ($accordionLabel.querySelectorAll('.accordion-icon')) {
    //     $accordionLabel.classList.add('has-icon');
    // } //todo do this logic with template?

    // Click event
    $accordionLabel.addEventListener('click', function (event) {
        // Get the Label element, not any children
        let limit, $el, $label;
        limit = 4, $el = event.target;
        while (limit-- > 0) {
            if ($el.classList.contains('accordion-label')) {
                $label = $el;
                break;
            }
            $el = $el.parentNode;
        }

        //if viewport size doesn't match, return
        let viewportSize = utilities.getViewportSize();
        if (!$label.parentNode.classList.contains('accordion-' + viewportSize) && !$label.parentNode.classList.contains('accordion-all')) {
            $accordionLabel.setAttribute("disabled", "");
            return;
        }
        else {
            $accordionLabel.removeAttribute("disabled");
        }

        //__________ Opening and Closing Action __________
        // if open, close
        if ($label.parentNode.classList.contains('accordion-open')) {
            // remove class
            $label.parentNode.classList.remove('accordion-open');
            // animate
            gsap.anim.closeDropDown($accordionContent, 0.1);

            // clear the settings (display, height, etc.) so it doesn't mess with different viewports if resized
            setTimeout(function(){
                TweenLite.set($accordionContent, {clearProps: "all"});
            }, 100); // only do it after animation is done
        }
        // else, open it
        else {
            // add class
            $label.parentNode.classList.add('accordion-open');
            // animate
            gsap.anim.openDropDown($accordionContent);
        }

    });
}

document.addEventListener('DOMContentLoaded', () => {
    for (let $element of document.querySelectorAll('.accordion')) {
        setupAccordions($element);
    }
});